import styled from 'styled-components';

export const TableFilterHeader = styled.div`
	display: flex;
	padding-bottom: 32px;
	width: 100%;

	@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
		display: none;
		position: relative;
	}
`;

export const HeadContainer = styled.div`
	align-items: center;
	display: flex;
	gap: 16px;
	justify-content: space-between;
	margin-bottom: 32px;
`;

export const TitlePage = styled.h1`
	align-items: end;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 32px;
	font-weight: 500;
	line-height: 1.1;

	svg {
		height: 40px;
		width: 40px;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 12px;
`;

export const NewSuscriptionButton = styled.button`
	background: ${({ theme }) => theme.colors.extra.earth};
	border: 0;
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.principal.pure};
	cursor: pointer;
	height: 37px;
	min-width: 100px;
	outline: 0;
	padding: 0 12px;
	transition: background-color 0.2s ease-in-out;
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}

	&:hover {
		opacity: 0.7;
	}
`;

export const RightSection = styled.div`
	background-color: ${({ theme }) => theme.colors.principal.eris};
	border-radius: 12px;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	padding: 8px 12px;
`;
